import urls from '../../urls';
import { route } from '../helpers';
import { PointStages } from '../../constants/AppConstants';
import SearchActions from '../../actions/SearchActions';

export default route(PointStages.INIT, {
    async onEnter ({ location, params }, replace, callback) {
        try {
            const definedParams = Object.keys(params).filter((key) => params[key] !== undefined);
            if (definedParams.length) {
                await SearchActions.loadFromParams(params, location.query);
            }
        } catch (error) {
            console.error(error);
        }

        replace(urls.location(PointStages.SEARCH));
        callback();
    }
});
